import React, { useState } from "react";
import "../../styles/Services.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import Application_bg_img from "../../bg_images/S_app_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";

const Servicesfaqs = [
  {
    question: "How much does it cost to pay a company to build an app?",
    answer:
      "The cost of app development varies depending on your project’s complexity and requirements. For accurate pricing tailored to your needs, please contact us with your specific requirements. ",
  },
  {
    question: "What is the best custom mobile app development company?",
    answer:
      "The best company is one that understands your vision and delivers tailored solutions. At Arshil, LLC, we pride ourselves on creating innovative, scalable, and secure apps Let's dicuss your project.",
  },
  {
    question: "How much do app developers charge?",
    answer:
      "Costs can vary significantly based on the developer’s experience and project scope. Reach out to us for a custom quote",
  },
  {
    question: "How much should I pay an app developer?",
    answer:
      "This depends on the features, design, and complexity of your app. For an accurate estimate, we’d love to hear about your project. Get in touch",
  },
];

const ApplicationDevelopment = () => {
  const navigate = useNavigate();
  const [ServicesopenIndex, ServicessetOpenIndex] = useState(null);

  const handleToggle = (index) => {
    ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
  };

  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{
          backgroundImage: `url(${Application_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "98.5vw",
        }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>{" "}
            Application Development
          </h5>
          <h2>Transform Ideas Into Impactful Applications</h2>
          <p>
            Arshil combines technical expertise and innovation to deliver custom
            web and mobile applications that empower businesses to grow and
            succeed
          </p>
          <button onClick={() => navigate("/contact")} className="S_sec1_btn1">
            Get In Touch
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2>What we Offer as an Application Development Company</h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec2_img1"
                src="../images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Custom Web Application Development:
                </span>{" "}
                Scalable and robust web solutions designed to meet your business
                goals.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec2_img1"
                src="../images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Mobile Application Development:
                </span>{" "}
                intuitive Android and iOS apps that captivate users and drive
                engagement.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec2_img1"
                src="../images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Cloud-Based Application Development:
                </span>{" "}
                Secure and efficient cloud-native apps for modern business
                needs.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec2_img1"
                src="../images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Enterprise Application Development:
                </span>{" "}
                Advanced solutions that streamline operations and enhance
                productivity.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec2_img1"
                src="../images/s_sec2_img5.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  AI-powered web applications: </span>
                 We embrace the latest advancements in AI to create intelligent,
                adaptive web applications that enhance user experiences and
                drive business growth.
              </h4>
            </section>
          </section>

          <section>
            <button
              onClick={() => navigate("/contact")}
              className="Service_sec2_in1_button"
            >
              Get a Free Quote
              <HiArrowNarrowRight className="s_sec2demoarrow" />
            </button>
          </section>
        </section>

        <section>
          <img className="s_sec2_img1" src="../images/S_app_dev.png" alt="" />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2>Why Choose Arshil as Your Application Developement partner?</h2>
          <p>
            At Arshil, we use our state-of-the-art platform, Akscel, designed to
            empower organizations to rapidly build and deploy applications with
            minimal resources, saving cost, time, effort, and human resources.
            Akscel makes it easier for us to deliver excellence and maximise
            resources.With Akscel, we accelerate development cycles and enhance
            project efficiency while ensuring enterprise-grade quality. Schedule
            a demo to see Akscel in action. Here's why businesses trust us:
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two_in1">
            <img src="../images/s_sec3_img1.png" alt="" />
            <h5>Rapid Development</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_sec3_img3.png" alt="" />
            <h5>Scalable Designs</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_sec3_img2.png" alt="" />
            <h5> Seamless Cross-Platform Compatibility </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_sec3_img5.png" alt="" />
            <h5> Cost-Effective Solutions</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_sec3_img5_s.png" alt="" />
            <h5> Enterprise-Grade Security </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_sec3_img8.png" alt="" />
            <h5> Agile and Flexible Development process</h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach to delivering state-of-the-art Applications </h1>
        <p>
          {" "}
          At Arshil, we start by understanding your vision, then craft solutions
          using proven methodologies and advanced technologies. Here is our
          approach to delivering high-quality applications{" "}
        </p>
        <ul className="Service_sec4_ul">
          <li>Understanding Your Needs </li>
          <li>User-Centered Design</li>
          <li>Agile Development</li>
          <li>Security First</li>
          <li>Scalability</li>
          <li>Collaboration and Transparency</li>
          <li>Quality Assurance</li>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      {/* Section 6 */}

      <div className="Sec8_container">
        <section>
          <h1>Ready to Build Your Future? </h1>
          <p>
            Let us create something extraordinary together. Contact us to start
            your application development journey. Arshil is always ready to help
            you accelerate with accuracy.
          </p>
        </section>

        <section className="Sec8_container_button">
          <button onClick={() => navigate("/contact")}>
            Contact us
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default ApplicationDevelopment;
